// @flow

import { runInAction, makeAutoObservable } from 'mobx';
import userApi from 'core/api/user.api';
import likeApi from 'core/api/like.api';
import jobAlertApi from 'core/api/jobAlert.api';

class SessionStore {
  user: any = {};
  loading: boolean = false;
  isCurrentUser: boolean = false;
  loadingLike: boolean = false;
  errors: any[] = [];

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  async getUser() {
    this.loading = true;

    try {
      const { data } = await userApi.fetch();
      runInAction(() => {
        this.loading = false;
        this.user = data;
        this.isCurrentUser = true;
      });
    } catch (error) {
      runInAction(() => {
        this.isCurrentUser = false;
        this.user = {};
      });
    }
  }

  async handleLike(params: any = {}) {
    const { likeId } = params;

    this.loadingLike = true;

    if (likeId) {
      try {
        await likeApi.destroy(likeId);

        this.user.likes = this.user.likes.filter(e => e.id !== likeId);
      } catch (error) {
        // console.error(error);
      }
    } else {
      try {
        const { data } = await likeApi.create(params);

        runInAction(() => {
          this.loadingLike = false;
          this.user.likes = [...this.user.likes, data];
        });
      } catch (error) {
        // console.error(error);
      }
    }
  }

  async addJobAlert(callback: (showInput: boolean) => void, params: {} = {}) {
    this.loadingLike = true;

    try {
      const { data } = await jobAlertApi.create(params);

      runInAction(() => {
        callback(false);
        this.loadingLike = false;
        this.user.jobAlerts = [
          ...this.user.jobAlerts,
          data
        ];
        this.errors = [];
      });

    } catch (error) {
      this.errors = error.errors;
    }
  }
}

export default new SessionStore();
